import CommonSelectInputWrapper from '@components/common/CommonSelectInputWrapper';
import ShareDataViewPopup from './ShareDataViewPopup';
import DownloadStickersModal from '@components/common/DownloadStickersModal';
import ButtonWrapper from '@components/common/ButtonWrapper';
import FavoriteUnfavoriteButton from './FavoriteUnfavoriteButton';
import LockUnlockButtonGroup from './LockUnlockButtonGroup';
import { identityFunction } from 'utils';
import { gridTemplatesOptions } from 'objects/StickerGridTemplate';
import { useTranslation } from 'react-i18next';
import { SHARE_DATA_VIEW } from '../../../../../constants';

type Props = {
  formikProps: any;
  selectedView: any;
  dataViewOnChange: (arg0: any, arg1: number) => void;
  dataViewListFiltered: any;
  actions: any;
  location: any;
  entityType: string;
  filterState: any;
  shareUrl: string;
  sharedDataViewName: string | null;
  inventoriesActions: any;
  setSelectedView: (arg0: any) => void;
  setIsCreatingNew: (arg0: boolean) => void;
  setNewDataViewName: (arg0: string) => void;
};

const DataViewOptions = ({
  formikProps,
  selectedView,
  dataViewOnChange,
  dataViewListFiltered,
  actions,
  location,
  entityType,
  filterState,
  shareUrl,
  sharedDataViewName,
  inventoriesActions,
  setSelectedView,
  setIsCreatingNew,
  setNewDataViewName,
}: Props) => {
  const { t } = useTranslation();
  const onClick = (setOpenModal: any) => {
    actions.getShareUrlDataView(
      sharedDataViewName || selectedView.text,
      selectedView.value,
      entityType,
      filterState,
      filterState.filterValues
    );
    setOpenModal(true);
  };

  const onCreateViewButton = () => {
    const { href } = window.location;
    window.history.replaceState('', '', href.substr(0, href.indexOf(SHARE_DATA_VIEW)));
    setIsCreatingNew(true);
    setNewDataViewName('');
  };

  return (
    <div>
      <span className="componentWithRightMargin">
        {t('inventory.overview.page.view.options.container.select.view.label')}
      </span>
      <CommonSelectInputWrapper
        {...formikProps}
        name="dataViewSelect"
        value={selectedView.value}
        onChange={(e: any, value: number) => dataViewOnChange(e, value)}
        options={dataViewListFiltered}
        className="viewSelectInlineBlock"
        title={selectedView.text}
      />
      <ShareDataViewPopup
        actions={actions}
        location={location}
        selectedView={selectedView}
        entityType={entityType}
        filterState={filterState}
        shareUrl={shareUrl}
        sharedDataViewName={sharedDataViewName}
      />

      <DownloadStickersModal
        key="export.qr.stickers.button"
        downloadStickersTriggerComponent={(setOpenModal: any) => (
          <ButtonWrapper
            icon="qrcode"
            type="button"
            className="mini"
            onClick={() => {
              onClick(setOpenModal);
            }}
          />
        )}
        createPDFActionMapper={inventoriesActions.createInventoriesQRStickersPdf}
        selectedItemsSupplier={() => [0]}
        itemsLabelsSupplier={() => ({ 0: `OVERVIEW: ${selectedView.text}` })}
        itemsLabelResultMapper={identityFunction}
        urlTemplateMapper={() => `${window.location.href}`}
        gridTemplateCreatorOptions={gridTemplatesOptions}
        downloadFileName={`view-${selectedView.text}-qr-sticker.pdf`.replace(/\s+/g, '')}
      />

      <FavoriteUnfavoriteButton
        selectedView={selectedView}
        actions={actions}
        entityType={entityType}
        setSelectedView={setSelectedView}
      />
      <LockUnlockButtonGroup
        selectedView={selectedView}
        actions={actions}
        entityType={entityType}
        setSelectedView={setSelectedView}
      />
      <ButtonWrapper
        label="inventory.overview.page.view.options.container.create.view.button"
        type="button"
        className="mini marginRightButton"
        onClick={() => {
          onCreateViewButton();
        }}
      />
    </div>
  );
};

export default DataViewOptions;
